import React, { useState, useEffect } from 'react';
import { Loader, NotFound } from '@shootsta/common-react';
import getOrgAlias from '@shootsta/get-alias';
import { getIdentityUrl } from '../utils';
import { RETURN_TO, TTL } from '../../../constants';
import LostPage from './LostPage';
import { getBaseDomain } from '../../../../utils';
import { canReauthenticate, getRedirectTTL } from '../../../utils';

type IdentityLoginProps = {
  getOrganisationNameFromAlias: any;
  flags?: any;
};

function checkData(dataKey: string) {
  return (result: any) => {
    if (
      !result ||
      result.error ||
      !result.data ||
      result.data[dataKey] == null
    ) {
      return Promise.reject(result.error || `${dataKey} is nil`);
    }
    return result.data[dataKey];
  };
}

export default function IdentityLogin({
  getOrganisationNameFromAlias,
  flags
}: IdentityLoginProps) {
  if (!flags || Object.keys(flags).length === 0) {
    return null;
  }

  const { enableUserLoginWithoutAlias = false } = flags || {};
  const [checkingOrgName, setCheckingOrgName] = useState(true);
  const [orgFound, setOrgFound] = useState(false);

  const baseDomain = getBaseDomain();
  const orgAlias = getOrgAlias();
  const returnToMinusProtocol = window.location.href.replace(
    /^https?:\/\//,
    ''
  );

  // Always define hooks before any conditional return
  useEffect(() => {
    if (!orgAlias) return;

    getOrganisationNameFromAlias({ alias: orgAlias })
      .then(checkData('getOrganisationNameFromAlias'))
      .then(() => setOrgFound(true))
      .catch((error) =>
        console.error('Error fetching organisation name:', error)
      )
      .finally(() => setCheckingOrgName(false));
  }, [orgAlias, getOrganisationNameFromAlias]);

  // Now safely do conditional rendering after all hooks
  if (!canReauthenticate()) {
    return <LostPage />;
  }

  if (enableUserLoginWithoutAlias || !orgAlias) {
    const addReturnTo = enableUserLoginWithoutAlias ? orgAlias : true;
    const queryParams = new URLSearchParams({
      ...(addReturnTo ? { [RETURN_TO]: returnToMinusProtocol } : {}),
      [TTL]: getRedirectTTL() || '1'
    });

    window.location.href = new URL(
      `?${queryParams.toString()}`,
      getIdentityUrl().href
    ).href;
    return <Loader />;
  }

  if (checkingOrgName) {
    return <Loader />;
  }

  if (!orgFound) {
    return <NotFound homeUrl={`${window.location.protocol}//${baseDomain}`} />;
  }

  const queryParams = new URLSearchParams({
    [RETURN_TO]: returnToMinusProtocol,
    [TTL]: getRedirectTTL() || '1'
  });

  window.location.href = new URL(
    `?${queryParams.toString()}`,
    getIdentityUrl().href
  ).href;
  return <Loader />;
}
